import React, { useState, useEffect } from 'react'
import langRu from 'assets/images/icons/ru.png'
import langEn from 'assets/images/icons/en.png'
import langAz from 'assets/images/icons/az.png'
import LoginForm from './LoginForm'
import PasswwordChange from './PasswordChange'
import MessageInput from './MessageInput'
import SmsInput from './SmsInput'
import OfficeEntrance from './OfficeEntrance'
import { connect } from 'react-redux'
import './sidebar.scss'

import { useActions } from '../../../../hooks/useActions'
import { changeLang } from 'store/actions/login'
import CustomNotifocation from 'components/CustomNotification'
import i18next from 'i18next'
import useResponsiveWidth from 'hooks/useResponsiveWidth'
import logo2 from 'assets/images/logo-2.svg'
import { useTranslation } from 'react-i18next'
import call from 'assets/images/icons/call_black.png'
import location from 'assets/images/icons/location.png'
import qrIOS from 'assets/images/qrIOS.svg'
import qrGoogle from 'assets/images/qrGoogle.svg'
import CustomTooltip from 'components/Tooltip'
import mobilOfisIcon from 'assets/images/mobilofis.svg'
import appStore from 'assets/images/appStore.svg'
import googlePlay from 'assets/images/googlePlay.svg'
import { Button } from 'antd'
import { WhatsApp } from '@mui/icons-material'
import { getMessageLists } from 'store/actions/home'
import { getDashboardMessage } from '../../../../services/message'

// const steps = [
//   {
//     id: '1',
//     title: 'login',
//     content: <LoginForm />,
//   },
//   {
//     id: '2',
//     title: 'message',
//     content: <MessageInput />,
//   },
//   {
//     id: '3',
//     title: 'sms',
//     content: <SmsInput />,
//   },
//   {
//     id: '4',
//     title: 'password',
//     content: <PasswwordChange />,
//   },
//   {
//     id: '5',
//     title: 'entrance',
//     content: <OfficeEntrance />,
//   },
// ]

const languages = [
  {
    id: 0,
    lang: 'AZ',
    img: langAz,
  },
  {
    id: 1,
    lang: 'EN',
    img: langEn,
  },
  {
    id: 2,
    lang: 'RU',
    img: langRu,
  },
]
const otherLangs = [
  {
    id: 1,
    lang: 'EN',
    img: langEn,
  },
  {
    id: 2,
    lang: 'RU',
    img: langRu,
  },
]

const SideBar: React.FC<any> = ({
  value,
  tabValue,
  errorMessage,
  notifyData,
  errorMessageAsan,
  notifyDataAsan,
  messageList,
}) => {
  const { changeLang, removeNotificationAsan } = useActions()
  const [selectedlang, setSelectedLang] = useState('az')
  const [diffArr, setDiffArr] = useState([])
  const [otherLangsData, setOtherLang] = useState(languages)
  const [pswStore, setPswStore] = useState<any>(null)
  const responsiveWidth = useResponsiveWidth()
  const { t } = useTranslation()
  const language = localStorage.getItem('i18nextLng')
  const [message, setMessage] = useState([])
  const [textArray, setTextArray] = useState([])
  const { getMessageLists } = useActions()

  useEffect(() => {
    if (!notifyDataAsan) return
    const timer = setTimeout(() => removeNotificationAsan(), 5000)
    return () => clearTimeout(timer)
  }, [notifyDataAsan])

  const steps = [
    {
      id: '1',
      title: 'login',
      content: <LoginForm setPswStore={setPswStore} pswStore={pswStore} />,
    },
    {
      id: '2',
      title: 'message',
      content: <MessageInput />,
    },
    {
      id: '3',
      title: 'sms',
      content: <SmsInput pswStore={pswStore} />,
    },
    {
      id: '4',
      title: 'password',
      content: <PasswwordChange />,
    },
    {
      id: '5',
      title: 'entrance',
      content: <OfficeEntrance />,
    },
  ]
  useEffect(() => {
    getDashboardMessage()
    getMessageLists()
    const fetchessageData = async () => {
      const message = await getDashboardMessage()
      if (
        message?.messageText !== undefined &&
        message?.messageText !== null &&
        message?.messageText !== ''
      ) {
        const array = message?.messageText.split('|')
        setMessage(array)
      }
    }

    fetchessageData()
  }, [])
  useEffect(() => {
    var diff = languages.filter(
      (e) => !otherLangsData.find((a) => e.lang == a.lang)
    )
    setDiffArr(diff[0])
  }, [selectedlang])
  useEffect(() => {
    const fetchessageData = async () => {
      let lang_text =
        messageList?.result !== undefined
          ? language == 'az'
            ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textAZE
            : language == 'ru'
            ? messageList.result.find(text=>text.messageKey === 'INFO.WHATSAPP')?.textRU
            : language == 'en'
            ? messageList.result.find(text=>text.messageKey === 'INFO.WHATSAPP')?.textENG
            : ''
          : ''

      const array = lang_text !== null  && lang_text !== undefined ? lang_text.split('https://wa.me/') : []
      console.log(array)

      setTextArray(array)
    }

    fetchessageData()
  }, [messageList, language])

  const NumbersDropDown = () => {
    return textArray
      .map((line: any, index: number) => {
        return line.startsWith('994')
          ? `<a href=${'https://wa.me/' + line}  key=${index} > ${
              '0' + line.substring(3)
            } </a> 
                        <br/>`
          : `<p key=${index}> ${line} </p>`
      })
      .join('')
  }
  const setLangData = async (item: string) => {
    await i18next.changeLanguage(item?.lang?.toLowerCase())
    localStorage.setItem('preferredLanguage', item?.lang?.toLowerCase())
    // history.go(0)
    setSelectedLang(item)
    //  otherLangsData[index] = {
    //    id: index,
    //    lang: diffArr.lang,
    //    img: diffArr.img
    //  }
    //  setOtherLang(otherLangsData)
    //  changeLang(item.lang)
  }

  // const NumbersDropDown = `
  // <div class='flex direction_column wp_numbers'>
  //     <p>${t("home.contactBank")}</p>
  //     <a href='https://wa.me/994774340777' target="_blank">(077) 434-07-77</a>
  //     <a href='https://wa.me/994774341777' target="_blank">(077) 434-17-77</a>
  //     <a href='https://wa.me/994774060777' target="_blank">(077) 406-07-77</a>
  // </div>`;

  const lang = localStorage.getItem('i18nextLng')
  // SIMA layout applies while the SİMA tab (tabValue==='4') is selected, so
  // the stacked layout is in place before the QR card appears. SIMA content
  // now always renders inside the same tab box as Login/Google/Asan (via
  // LoginForm > SIMAForm), so there's no separate DOM shape to reconcile.
  const isSimaLayout = `${tabValue}` === '4'
  return (
    <div className={`sidebar${isSimaLayout ? ' sidebar--sima' : ''}`}>
      {errorMessage && notifyData && (
        <CustomNotifocation message={errorMessage[0].MESSAGE} />
      )}
      {errorMessageAsan && notifyDataAsan && (
        <CustomNotifocation message={errorMessageAsan[0].MESSAGE} />
      )}

      <div className="loginHeader">
        {responsiveWidth <= 992 && <img src={logo2} />}
        <ul className="language-panel">
          {otherLangsData.map((item, index) => {
            return item.lang.toLowerCase() !== (lang || selectedlang) ? (
              <li>
                <a onClick={() => setLangData(item, index)}>
                  <img src={item.img}></img>
                  <span>{item.lang}</span>
                </a>
              </li>
            ) : (
              <></>
            )
          })}
        </ul>
      </div>
      <div className={`loginMain${isSimaLayout ? ' loginMain--sima' : ''}`}>
        {steps[value].content}
        {responsiveWidth <= 992 && (
          <CustomTooltip
            title={NumbersDropDown()}
            placement={'left'}
            className={'wp_tooltips'}
          >
            <Button
              className="wp_ico flex justify_center align_center icon-login_responsive"
              icon={<WhatsApp />}
            />
          </CustomTooltip>
        )}
      </div>
      <div className='loginAppQR-main'>
        <div className="loginAppQR" style={{position:'static'}}>
          <p className='title'><img src={mobilOfisIcon}/>Mobil Ofis Biznes</p>
          <div className='qrCodes flex justify_around'>
            <div className='appStore'>
              <img src={qrIOS} alt="qr" />
              <p><img src={appStore}/></p>
            </div>
            <div>
              <img src={qrGoogle} alt="qr" />
              <p><img src={googlePlay}/></p>
            </div>
          </div>
        </div>
      </div>
     
      {responsiveWidth <= 992 && (
        <div className="loginFooter">
          <ul>
            <li>
              <img src={location} />
              <a
                target="_blank"
                href={`http://www.bankrespublika.az/${lang}/branches`}
              >
                {t('login.atmBranches')}
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href={`http://www.bankrespublika.az/uploads/pdfs/Tarifler%20%28huquqi_sexsler%29_${lang}.pdf`}
              >
                {t('login.tariffs')}
              </a>
            </li>
            <li>
              <img src={call} alt="call" />
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  value: state.login.value ? state.login.value : 0,
  tabValue: state.login ? state.login.tabValue : '1',
  lang: state.login.lang,
  notifyData: state.googleAuth.notify,
  errorMessage: state.googleAuth.error ? state.googleAuth.error.messages : '',
  notifyDataAsan: state.token.notify ? state.token.notify : false,
  errorMessageAsan: state.token.error ? state.token.error.messages : '',
  messageList: state.home.messageList,
})
const mapDispatchToProps = { changeLang, getMessageLists }

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)
